module.exports = __webpack_public_path__ + "static/bg2-abaeba4724f094b0140a5202f25954e2.png";